<template>
<div class="list" :style="{height: off_height}">
    <div class="school-uniform-item" v-for="(item,index) in school_uniform" :key="index" @click="go_details(item)">
        <div class="school-uniform-img">
            <img :src="imgUrl + item.pic">
        </div>
        <div class="school-uniform-title one-lin-text-show">{{item.name}}</div>
        <div class="school-uniform-money money-of-sum">￥{{item.price_yuan}}</div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            off_height: 0,
            imgUrl: this.$commonVariable.imgUrl,
            school_uniform: [],
        }
    },
    created(){
        this.call_list()
        this.off_height = ((document.body.clientHeight / 100) - 50) + 'rem'
    },
    methods: {
            // console.log(this.pub_fun.centToYuan(20000));
        call_list(){
            this.$service.list({
                idCategory: '',
                page: 1,
                limit: 200,
            }).then(res => {
                this.school_uniform = res.data.records
                this.school_uniform.forEach(item => {
                    item.price_yuan = this.pub_fun.centToYuan(item.price)
                })
            })
        },
        go_details(val){
            this.$router.push({
                path: '/details',
                query: {
                    guid: val.id,
                }
            })
        },
    },
}
</script>

<style lang="less" scoped>
    .list{
        display: flex;
        flex-wrap: wrap;
        padding: 0.25rem 0;
        // height: 100%;

        .school-uniform-item{
            width: 3.5rem;
            height: 4.65rem;
            padding-bottom: 0.25rem;
            margin: 0 0 0.15rem 0.15rem;
            display: flex;
            flex-direction: column;
            background-color: #fff;
            border-radius: 10px;
            overflow: hidden;

            .school-uniform-img{
                width: 100%;
                height: 3.7rem;

                >img{
                    width: 100%;
                    height: 100%;
                }
            }

            .school-uniform-money{
                box-sizing: border-box;
                width: 100%;
                padding: 0 0.2rem;
                font-size: 0.3rem;
                display: block;
            }
        }
    }
</style>
